import type { ChatTask } from "@/sdk/agent/chat";
import type { QueuedChatProps } from "./QueuedChat";
import { QueuedChat } from "./QueuedChat";
import { getChatVariant, getColorByVariant } from "./variants";

export interface ChatListProps extends Pick<QueuedChatProps, "onChatSelected"> {
    chats: ChatTask[];
    isSelectedChat: (chat: ChatTask) => boolean;
}

export function FlatChatList({ chats, onChatSelected, isSelectedChat }: ChatListProps) {
    const avatars = chats.map((chat: ChatTask) => {
        const isChatSelected = isSelectedChat(chat);
        const variant = getChatVariant(chat);
        const variantColor = getColorByVariant(variant);

        const shared = { chat, variant, variantColor };

        return (
            <QueuedChat
                key={`chat-select-chatId:${chat.chatId}`}
                {...shared}
                onChatSelected={onChatSelected}
                isChatSelected={isChatSelected}
            />
        );
    });

    return avatars;
}
